export default __webpack_public_path__ + "media/images/lp/conversion-button-sp-aaed040e6df0dc7cb5443995d59cab4e.png";